import { type PropsWithChildren } from "react";
import { cn } from "ui";

interface SectionFieldsContainerProps extends PropsWithChildren {
  onClick?: (e: React.MouseEvent) => void;
}

export function SectionFieldsContainer(props: SectionFieldsContainerProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 p-3 rounded-lg",
        "bg-gradient-to-br from-slate-50/80 to-slate-100/50",
        "border border-slate-200/60",
      )}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}
